import { getFeatureFlag } from '../services/feature-flag-helpers';
import { EFeatureFlag } from '../services/feature-flags-consts';

export function shouldPreloadLibraries(): boolean {
  return !getFeatureFlag(EFeatureFlag.LAZY_LOAD_LIBRARIES);
}

export function preloadLibraries(): void {
  const preload = (): void => {
    if (!shouldPreloadLibraries()) {
      return;
    }

    import('exceljs').catch(() => undefined);
    import('xlsx').catch(() => undefined);
    import('browser-image-compression').catch(() => undefined);
  };

  if (typeof requestIdleCallback === 'function') {
    requestIdleCallback(preload);

    return;
  }

  setTimeout(preload, 0);
}
